import { withCitrusTheme, Button } from '@gousto-internal/citrus-react'

export const StyledButton = withCitrusTheme(Button, (theme) => ({
  '&:hover, :disabled, :disabled:hover, :disabled:focus': {
    color: theme.tokens.colors.White,
  },
}))
